export class HandlebarNumber {
  value: number;

  protected constructor(value: number) {
    this.value = value;
  }

  get isNaN() {
    return Number.isNaN(this.value);
  }
}
